






















































import {
  editIntegralGoodsStockData,
  editIntegralGoodsStockApi,
  getIntegralGoodsDetailApi,
} from "@/api/integral";
import { positivePass } from "@/utils/rules";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() goodsId!: number;
  form: any = {};
  dialogVisible: boolean = false;
  rules = {
    stock: [
      { required: true, message: "请填写库存数", trigger: "blur" },
      { validator: positivePass, trigger: "blur" },
    ],
  };
  openDialog() {
    if (!this.goodsId) {
      return false;
    }
    getIntegralGoodsDetailApi({ goods_id: this.goodsId }).then((res) => {
      this.form = {
        goods_name: res.data.goods_name,
        old: res.data.stock,
        action_type: 1,
        stock: 1,
      };
    });
    this.dialogVisible = true;
  }
  handleClose() {
    this.dialogVisible = false;
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          editIntegralGoodsStockApi({
            goods_id: this.goodsId,
            action_type: this.form.action_type,
            stock: this.form.stock,
          }).then(() => {
            this.$message({
              type: "success",
              message: `库存已${this.form.action_type === 1 ? "增加" : "扣除"}`,
            });
            this.handleClose();
            this.$emit("change");
          });
        }
      }
    );
  }
}
